export default __webpack_public_path__ + "zap.svg?8dbcae1e48d1b92a07868ba988886986";